import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import useSubWorkspaceCategories from '@/modules/corporate/modules/discover/views/Category/hooks/useSubWorkspaceCategories';
import { getFilteredTagsByWorkspaceForSubmit } from '@/modules/corporate/modules/tags/utils';
import AddWorkspaceSettingsModal from '@/modules/corporate/modules/workspaceSettings/components/AddWorkspaceSettingsModal';
import { DEFAULT_WORKSPACE_IDS } from '@/modules/corporate/modules/workspaceSettings/const';
import { EntityTagType } from '@/types/schema';

import { DialogProps } from '../../types';

const WorkspaceSettings: React.FC<DialogProps> = ({ content, onSubmit, onClose }) => {
  const { t } = useTranslation();
  const selectedWorkspaces = content.subWorkspaces || DEFAULT_WORKSPACE_IDS;

  const { getCategoriesOnSubWorkspaceChange } = useSubWorkspaceCategories();

  const onModalSubmit = useCallback(
    async (subWorkspaceIds?: string[] | null) => {
      const { categoryIds: updatedCategoryIds, error } = await getCategoriesOnSubWorkspaceChange(
        content.categoryIds,
        subWorkspaceIds,
      );

      if (error) {
        return Promise.resolve(false);
      }

      onSubmit?.({
        subWorkspaceIds,
        categoryIds: updatedCategoryIds ? { set: updatedCategoryIds } : undefined,
        tags: getFilteredTagsByWorkspaceForSubmit({
          entityTags: content.tags as EntityTagType[],
          subWorkspaceIds,
        }),
      });

      return Promise.resolve(true);
    },
    [content.categoryIds, content.tags, getCategoriesOnSubWorkspaceChange, onSubmit],
  );

  return (
    <AddWorkspaceSettingsModal
      contentName={t('Common:ResourceType.Article')}
      selectedWorkspaces={selectedWorkspaces}
      onClose={onClose}
      onSubmit={onModalSubmit}
    />
  );
};

export default WorkspaceSettings;
